<div class="update-modal-container">
  <div class="update-modal-header">
    <span class="update-icon">&#9889;</span>
    <div>
      <h2 class="update-title" mat-dialog-title>Nova versão disponível</h2>
      <p class="update-subtitle">Atualização necessária</p>
    </div>
  </div>

  <p class="update-body">
    O sistema foi atualizado. Para continuar usando corretamente, atualize agora ou em até <strong>30 minutos</strong>.
  </p>

  <div class="update-warning">
    <span>&#9888;</span>
    <span>Você será desconectado e precisará fazer login novamente ao confirmar.</span>
  </div>

  <div class="update-actions">
    <button type="button" class="update-btn-cancel" (click)="dismiss()">Depois (30 min)</button>
    <button type="button" class="update-btn-primary" (click)="update()">Atualizar agora</button>
  </div>
</div>
